import {GridColDef} from '@mui/x-data-grid-pro';
import {renderCellDate} from '../../../utils/renderCellDate';
import {renderCellCurrency} from '../../../utils/renderCellCurrency';

export const liabilitiesColumns: GridColDef[] = [
  {
    field: 'contact',
    headerName: 'Owner',
    flex: 1,
    editable: false,
    headerAlign: 'left',
    sortable: false,
    renderCell(params) {
      return params.value?.simplifiedName || '-';
    },
  },
  {
    field: 'product',
    headerName: 'Product',
    flex: 1,
    editable: false,
    headerAlign: 'left',
    sortable: false,
    renderCell(params) {
      return params.value?.reportName || params.value?.name || '-';
    },
  },
  {
    field: 'provider',
    headerName: 'Lender',
    flex: 1,
    editable: false,
    headerAlign: 'left',
    sortable: false,
    renderCell(params) {
      return params.value?.reportName || params.value?.name || '-';
    },
  },
  {
    field: 'category',
    headerName: 'Category',
    flex: 1,
    editable: false,
    headerAlign: 'left',
    sortable: false,
  },
  {
    field: 'currentDebt',
    headerName: 'Current debt',
    flex: 1,
    editable: false,
    headerAlign: 'left',
    sortable: false,
    renderCell: renderCellCurrency,
  },
  {
    field: 'asAtDate',
    headerName: 'As at date',
    flex: 1,
    editable: false,
    headerAlign: 'left',
    sortable: false,
    renderCell: renderCellDate,
  },
  {
    field: 'repaymentAmount',
    headerName: 'Repayment amount',
    flex: 1,
    editable: false,
    headerAlign: 'left',
    sortable: false,
    renderCell: renderCellCurrency,
  },
  {
    field: 'frequency',
    headerName: 'Repayment frequency',
    flex: 1,
    editable: false,
    headerAlign: 'left',
    sortable: false,
  },
];
